<template>
  <div class="pb-2 pl-px">
    <transition-group class="mt-6 flex flex-col gap-3"
                      name="fade"
                      tag="div"
    >
      <condition-case-browser-url-operand v-for="(operand, i) in operands"
                                          :key="`${i}`"
                                          :operand.sync="operands[i]"
                                          :index="i"
                                          :logic-operator="logicOperator"
                                          :has-minimal-operands="hasMinimalOperands"
                                          :state-id="stateId"
                                          @update:logic-operator="logicOperator = $event"
                                          @remove:operand="removeOperand(i)"
      />
    </transition-group>

    <base-tooltip-button variant="hover:transparent-gray"
                         :tooltip-enabled="hasMaximumOperands"
                         :is-disabled="hasMaximumOperands"
                         class="mt-4 ml-1 w-max"
                         tooltip-text="A maximal count of conditions is 5."
                         @click="addOperand"
    >
      <span class="font-semibold text-sm text-gray-dark">+ Add more</span>
    </base-tooltip-button>
  </div>
</template>

<script>
import append from 'ramda/src/append'
import remove from 'ramda/src/remove'
import ConditionCaseBrowserUrlOperand from './ConditionCaseBrowserUrlOperand'
import conditionUtils from '@/utils/condition.utils'
import regularExpressionUtils from '@/utils/key-regex.utils'
import BaseTooltipButton from '@/components/base-components/BaseTooltipButton'
import { MATCH_OPERATORS } from '@/utils/key-regex.constants'
import { CONDITION_CASES } from '@/store/constants'

export default {
  name: 'ConditionCaseBrowserUrl',

  components: {
    BaseTooltipButton,
    ConditionCaseBrowserUrlOperand
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    },
    stateId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      operands: [],
      logicOperator: 'and'
    }
  },

  computed: {
    hasMaximumOperands() {
      const max = 5
      return this.operands.length >= max
    },

    hasMinimalOperands() {
      const min = 1
      return this.operands.length <= min
    }
  },

  watch: {
    stateId: {
      deep: true,
      immediate: true,
      handler() {
        this.logicOperator = regularExpressionUtils.parseRegexToLogic(this.value.regex)
        this.operands = regularExpressionUtils.parseRegexToOperands(this.value.regex, this.logicOperator)
      }
    },

    operands: {
      deep: true,
      immediate: false,
      handler(operands) {
        this.updateCondition(operands)
      }
    },

    logicOperator() {
      this.updateCondition(this.operands)
    }
  },

  methods: {
    addOperand() {
      if (this.hasMaximumOperands) return

      const newOperand = {
        matchOperator: MATCH_OPERATORS.WITH,
        text: '',
        regex: ''
      }
      this.operands = append(newOperand, this.operands)
    },

    removeOperand(i) {
      this.operands = remove(i, 1, this.operands)
    },

    updateCondition(operands) {
      const regexes = regularExpressionUtils.arrayRegexes(operands)
      const regex = regularExpressionUtils.combineRegexes(regexes, this.logicOperator)
      const condition = { key: 'browserUrl', regex }
      const payload = conditionUtils.createConditionJson(CONDITION_CASES.BROWSER_URL, condition)

      this.$emit('input', payload)
    }
  }
}
</script>
